import { MigrationDefinition } from './migration.types';

/**
 * Migration: V5 → V6
 *
 * Upgrade:
 * - Leeres projects-Array hinzufügen (header.projects = [])
 *
 * Downgrade:
 * - projects-Array NICHT löschen - alte App ignoriert es einfach
 */
export const migrationV5ToV6: MigrationDefinition = {
  fromVersion: 5,
  toVersion: 6,

  upgrade(doc: any): any {
    if (!doc.header.projects) {
      doc.header.projects = [];
    }

    doc.version = 6;
    return doc;
  },

  downgrade(doc: any): any {
    // projects-Array NICHT löschen - alte App ignoriert es,
    // aber Daten bleiben für späteres Upgrade erhalten
    doc.version = 5;
    return doc;
  },

  dataLossWarnings: []
};
